<section class="hero--bg hero" id="hero" style="margin-bottom: -5rem">
  <header id="header" class="container">
    <mwe-header-logo />
  </header>
  @if (isLoaded()) {
    <header class="hero-header container pb-8">
      <div class="row">
        <div class="col-lg-7 align-self-center">
          @if (showAuthServerAlert()) {
            @if (authServerAlertData().type === 'danger') {
              <div class="mb-4">
                <mwe-inline-notification
                  class="text-neutral-600"
                  [type]="authServerAlertData().type"
                  [titleKey]="authServerAlertData().title"
                  [messageKey]="authServerAlertData().message"
                />
              </div>
            } @else {
              <div class="mb-4">
                <mwe-infobox
                  [type]="authServerAlertData().type"
                  [titleKey]="authServerAlertData().title"
                  [messageKey]="authServerAlertData().message"
                />
              </div>
            }
          }
          <h1 class="mb-5 mb-lg-6">
            <div class="h6 mb-3 text-white">
              @if (content()?.titleSmall) {
                <span>{{ content().titleSmall }}</span>
              } @else {
                <span translate="home.titleSmall"></span>
              }
            </div>
            <div class="h1 mb-0 text-white">
              @if (content()?.titleLarge) {
                <span>{{ content().titleLarge }}</span>
              } @else {
                <span [translate]="titleBigLabelKey()"></span>
              }
            </div>
          </h1>

          @if (content()?.subtitle) {
            <h3 class="text-white pb-3">{{ content().subtitle }}</h3>
          }

          @if (isEmailInvitationLandingPage()) {
            <p class="hero-copytext" translate="home.subtitle_emailInvitation"></p>
          } @else if (content()?.copyText) {
            <p class="hero-copytext pb-7">
              {{ content().copyText }}
            </p>
          }

          <div class="mb-5 mb-lg-6">
            <mwe-button
              [showHoverEffect]="true"
              (clicked)="login()"
              class="d-block mb-3"
              buttonId="mwe-home-login"
              color="white"
              labelKey="home.login"
            />
            <mwe-button
              (clicked)="register()"
              buttonId="mwe-home-register"
              color="white"
              category="secondary"
              labelKey="home.register"
              class="d-block mb-3"
            />
          </div>
          <p class="mt-5 mt-lg-6">
            <span [translate]="wrongPortalKeys().text"></span>
            <a
              class="text-white focus-inverted link-hover-behaviour"
              tabindex="0"
              [translate]="wrongPortalKeys().link"
              [href]="switchPortalUrl()"
            ></a
            >.
            @if (wrongPortalKeys().text2 && (wrongPortalKeys().text2 | translate)) {
              <br />
              <span [innerHTML]="wrongPortalKeys().text2 | translate"></span>
            }
          </p>
          @if (content()?.legalText) {
            <p>
              <small [innerHTML]="content().legalText | safeHtml"></small>
            </p>
          }
        </div>
        <div class="col-lg-5 position-relative d-lg-block d-none" aria-hidden="true">
          @if (!content()?.imageSmartphoneBg) {
            <img
              class="img-fluid d-block ml-auto"
              style="max-width: 360px"
              [src]="content().imageUri"
              alt="Illustration Container"
              [ngStyle]="{ cursor: content()?.imageHref ? 'pointer' : 'inherit' }"
              (click)="content()?.imageHref ? navigateToCampaignUri() : undefined"
            />
          } @else {
            <div class="mx-auto ratio ratio-smartphone" style="max-width: 236px; filter: drop-shadow(0 22px 45px rgba(0, 0, 0, 0.33))">
              <div class="smartphone-display">
                <img
                  class="img-fluid w-100 rounded"
                  [src]="content().imageUri"
                  alt="Illustration Container"
                  [ngStyle]="{ cursor: content()?.imageHref ? 'pointer' : 'inherit' }"
                  (click)="content()?.imageHref ? navigateToCampaignUri() : undefined"
                />
              </div>
            </div>
          }
        </div>
      </div>
    </header>
  }
</section>
